import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey2, grey5 } from 'approot/shared/styles/colours.style';
import {
  Heading24,
  fontWeightBold,
} from 'approot/shared/styles/typography.style';
import {
  spacing4,
  spacing8,
  spacing12,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const InteractiveResponsePrintCategories = styled.div`
  display: flex;
  padding: 0 ${rem(spacing16)};
`;

export const InteractiveResponsePrintCategory = styled.div`
  flex: 1;
  padding: 0 ${rem(spacing8)};
`;

export const InteractiveResponsePrintCategoryLabel = styled(Heading24)`
  font-weight: ${fontWeightBold};
  text-align: center;
`;

export const InteractiveResponsePrintCategoriseDropTarget = styled.div`
  ${flexCentreAlignCss}

  background-color: ${grey2};
  border: 2px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  color: ${grey5};
  padding: ${rem(spacing12)};
  min-height: ${rem(128)};
`;

export const InteractiveResponsePrintDragZone = styled(BoxList)`
  ${flexCentreAlignCss}

  flex-wrap: wrap;
  margin: auto;
  min-height: ${rem(140)};
  position: relative;
  flex-wrap: wrap;
`;

export const InteractiveResponsePrintDragZoneItem = styled.li`
  margin: 0 ${rem(spacing4)} ${rem(spacing8)} ${rem(spacing4)};
`;
